import { z } from 'zod';

export const calendarResourceTypes = {
  SEMINARRAUM: 'seminarraum', // Haupt-Raum der Veranstaltung: Standardraum (in Hotel) | Raum in PC-Center | Raum in Veranstaltungslocation
  GRUPPENRAUM: 'gruppenraum',
  STANDORT: 'standort',
  EXPERTE: 'experte',
} as const;

export type CalendarResourceType = (typeof calendarResourceTypes)[keyof typeof calendarResourceTypes];
export type CalendarRaumResourceType = (typeof calendarResourceTypes)['SEMINARRAUM' | 'GRUPPENRAUM'];
export const calendarResourceTypeSchema = z.enum(calendarResourceTypes);
